<template>
  <div class="questionBox">
    <ul>
      <li
        v-for="(item, index) in questionList"
        :key="index"
        :class="questionIndex == index ? 'active' : ''"
        @click="goto(index)"
      >
        <div class="questionDetail">
          <p class="name">{{ item.name }}</p>
          <p class="describe">{{ item.describe }}</p>
        </div>
        <div :class="['questionDetailList',questionIndex == index ? 'showList' : '']">
          <ul>
            <li
              v-for="(item1, index1) in item.list"
              :key="index + index1"
            >
              <p>{{ item1.name }}</p>
                <div class="content" v-html="item1.content"></div>
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import data from './questionData.json'

export default {
  metaInfo() {
    return {
      title: "常见问题",
    };
  },
  name: "question",
  data() {
    return {
      questionIndex: -1,
      questionList: [
        {
          helptype: 2000,
          name: "账户问题",
          describe: "账号注销、个人信息等",
          list: [...data[2000]],
        },
        {
          helptype: 2001,
          name: "教学问题",
          describe: "购买课程、充值、会员等",
          list: [...data[2001]],
        },
        {
          helptype: 2002,
          name: "直播问题",
          describe: "预约直播、打赏记录等",
          list: [...data[2002]],
        },
         {
          helptype: 2003,
          name: "交易问题",
          describe: "绑定银行卡、查询收益明细等",
          list: [...data[2003]],
        },
        {
          helptype: 2004,
          name: "使用问题",
          describe: "艺术家之家、如何管理作品集等",
          list: [...data[2004]],
        },
      ],
    };
  },
  components: {},
  mounted() {
  },
  methods: {
    goto(index) {
      this.questionIndex=this.questionIndex==index?-1:index;
      
    },
  },
};
</script>

<style lang="scss" scoped>
.questionBox {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  height: 100%;
  background: #f4f4f7;
  padding: 16px 16px;
  overflow: auto;
  > ul {
    > li {
      background: #ffffff;
      margin-bottom: 16px;
      .questionDetail {
        padding: 20px 0;
        margin: 0 16px;
        padding-right: 20px;
        position: relative;
        .name {
          font-size: 16px;
          line-height: 22px;
          color: #35363c;
          font-weight: 500;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .describe {
          font-size: 12px;
          font-weight: 300;
          line-height: 21px;
          color: #35363c;
          margin-top: 8px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .questionDetailList {
        background: #ffffff;
        height: 0;
        overflow: hidden;
        transition: all linear 0.2s;
        li {
          // display: flex;
          // flex-direction: row;
          // align-items: center;
          // justify-content: space-between;
          padding:16px;
          border-top: 1px solid #ededed;
          p {
            // padding: 16px 0;
            // flex: 1;
            // white-space: nowrap;
            // overflow: hidden;
            // text-overflow: ellipsis;
            font-size: 14px;
            font-weight: 300;
            line-height: 20px;
            color: #35363c;
          }
          .content{
            font-size: 12px;
            color: #35363c;
            margin-top: 8px;
          }
          i {
            display: inline-block;
            width: 24px;
            height: 24px;
            background: url(../../../assets/img/h5/triangle_d_b.png) no-repeat;
            transform: rotate(0deg);
            background-size: 24px 24px;
          }
        }
      }
      .showList {
        height: auto;
        overflow: hidden;
        transition: all linear 0.2s;
      }
      .questionDetail::before {
        content: " ";
        display: inline-block;
        width: 24px;
        height: 24px;
        background: url(../../../assets/img/h5/arrow_d_b.png) no-repeat;
        background-size: 24px 24px;
        position: absolute;
        right: 0;
        top: 50%;
        margin-top: -12px;
        transform: rotate(-90deg);
        transition: all linear 0.2s;
      }
    }
    // > li:not(:last-child) .questionDetail {
    //   border-bottom: 1px solid #ededed;
    // }
    > li.active .questionDetail {
      border-bottom-color: transparent;
      padding-bottom: 12px;
    }
    > li.active .questionDetail::before {
      transform: rotate(-180deg);
      transition: all linear 0.2s;
    }
  }
}
</style>